"use client"

import { useEffect, type ReactNode } from "react"
import { useRouter, usePathname } from "next/navigation"
import { api } from "@/lib/api-client"

export default function AuthLayout({ children }: { children: ReactNode }) {
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    const { accessToken } = api.getTokens()
    if (accessToken) {
      const locale = pathname.split("/")[1] || "en"
      router.replace(`/${locale}/dashboard`)
    }
  }, [pathname, router])

  return <div className="min-h-screen bg-canvas-dark">{children}</div>
}
